function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DocumentBuilder } from './parser/document-builder';
import BlockParser from './parser/block-parser';
export default class BlocksParser {
  constructor(schema) {
    _defineProperty(this, "schema", void 0);
    this.schema = schema;
  }
  parse(blocksDocument, config) {
    let documentBuilder = new DocumentBuilder(this.schema);
    let blockParser = new BlockParser(documentBuilder, config);
    let blocks = blocksDocument.blocks;
    blocks.forEach((block, index) => {
      blockParser.handle(block, blocks[index + 1]);
    });
    return documentBuilder.doc;
  }
}